<div class="modal-header p-3">New Update</div>
<div class="w-100 p-3 text-center">
  <form #updateForm="ngForm">
    <div class="fs-6 w-100">
      <table class="w-100">
        <tr>
          <td class="w-50 align-top text-start">
            <div>Description</div>
            <input type="text" class="form-control" placeholder="Update description"
              [(ngModel)]="data.name" name="name" required>
              @if (!submittingUpdate) {
                <div>
                  <div class="d-inline-block">Attachment (<i>max file size: 20MB</i>)</div>
                  @if (files.length === 0) {
                    <div class="d-inline-block">
                      <input type="file" (change)="onFileChange($event)" multiple>
                    </div>
                  }
                  @for (item of files; track item) {
                    <div>
                      <div class="row">
                        <div class="col-lg-12">
                          <div><i>{{item.name}}</i></div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (submittingUpdate) {
                <div class="progress-center progressfade">
                  <span class="progress-label">Sending Update...</span>
                </div>
              }
              <br>
                @if (showErrorMessage) {
                  <div class="alert alert-danger" role="alert">{{errorMessage}}</div>
                }
              </td>
              <td class="w-50 ps-3 align-top text-start">
                <div class="w-95 p-2 border border-999 rounded">
                  <table class="w-100">
                    <tr><td>Latitude:</td><td> {{data.lat}}</td></tr>
                    <tr><td>Longitude:</td><td> {{data.lon}}</td></tr>
                    @if (data.isInsideBuilding) {
                      <tr><td>Perimeter:</td><td> {{data.clickedPerimeter?.label}} {{data.clickedPerimeter?.arcAngelId}}</td></tr>
                    }
                  </table>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="fs-6 w-100 p-0 d-inline-block">
          <span class="float-start">
            <span>
              <input type="checkbox" [(ngModel)]="data.isInsideBuilding" name="isInsideBuilding" (change)="isInsideBuildingClicked()" />
              This update is inside a building
            </span>
            @if (data.isInsideBuilding) {
              <span>(click on the floor to define the update location)</span>
            }
          </span>
        </div>
        @if (data.isInsideBuilding) {
          <div class="fs-6 w-100 border border-fff p-2 d-inline-block">
            <table class="w-100 mb-2">
              <tr>
                <td class="w-33">
                  Building:<br>
                  <select class="form-control" [(ngModel)]="data.selectedBuilding" name="selectedBuilding">
                    @for (item of data.buildings; track item) {
                      <option [ngValue]="item">{{item.name}}</option>
                    }
                  </select>
                </td>
                <td class="w-33">
                  Floor:<br>
                  <select class="form-control" [(ngModel)]="data.selectedFloor" name="selectedFloor" (change)="floorChanged()" [compareWith]="comparePerimeter">
                    @for (item of data.selectedBuilding?.floorPerimeters; track item) {
                      <option [ngValue]="item">{{ item.name }}</option>
                    }
                  </select>
                </td>
              </tr>
            </table>
            <div id="new-update-map" class="w-100" style="height: 400px; background-color: #888"></div>
          </div>
        }
        <div class="row m-3">
          <div class="col-lg-3"></div>
          <div class="col-lg-3">
            <button type="button" class="btn btn-danger w-100" [disabled]="submittingUpdate" (click)="send()">Send</button>
          </div>
          <div class="col-lg-3">
            <button type="button" class="btn btn-default w-100" (click)="cancel()">Cancel</button>
          </div>
          <div class="col-lg-3"></div>
        </div>
      </form>
    </div>